import { Text, Button } from '@simplywallst/ui-core';
import styled from 'styled-components';
import { useProApiRegistration } from '../../hooks/useProApiRegistration';
const LinkButton = styled(Button)`
  cursor: pointer;
`;

export function RestrictedAccess() {
  const { status, mutate } = useProApiRegistration();
  return (
    <>
      <Text data-cy-id="restricted-copy">
        You currently do not have access to our Pro API.
        <LinkButton
          as="a"
          styleType="strongLink"
          onClick={() => mutate()}
          isLoading={status === 'pending'}
        >
          Register
        </LinkButton>
        .
      </Text>
    </>
  );
}
